<template>
  <div>
    <div class="col-12 lg:col-12 px-0">
      <Toolbar class="mb-2">
        <template #start>
          <div class="grid">
            <div class="col-12">
              <Dropdown class="w-full" v-model="selectedUnidadFiltro" :options="lstUnidades"
                optionLabel="UNIDAD_SUBRED" placeholder="Selecciona una unidad" style="margin-bottom: 10px;"
                :showClear="false" :filter="true" :loading="loadingEquipos" @change="cargaEquiposPorUnidad"/>
              <label>¿Comparar datos con OCS?</label><input type="checkbox" id="id_datos_OCS">
            </div>
          </div>
        </template>
        <template #end>
          <Button label="Cancelar Cambios" id="btn-cancelar" icon="pi pi-times" class="p-button-danger mr-2" @click="cancelarTodo"/>
          <Button label="Guardar Cambios" id="btn-guardar" icon="pi pi-save" class="p-button-primary mr-2" @click.prevent="guardarCambios"/>
        </template>
      </Toolbar>
    </div>

    <DataTable
      v-if="selectedUnidadFiltro && selectedUnidadFiltro.SUBRED != ''"
      :value="lstEquipos"
      v-model:expandedRows="expandedRowsSegmentados"
      dataKey="IP"
      editMode="cell"
      :rowClass="rowClass"
      v-model:filters="filtersSegmentados"
      @cell-edit-complete="EditarEquipo"
      :globalFilterFields="[  
        'Unidad', 'SUBRED', 'Ubicacion', 'Usuario', 'Serie', 'SO',  
        'Nombre_equipo', 'NNI', 'Area', 'Observaciones', 'Descripcion',  
        'IP', 'Marca', 'MAC', 'Modelo', 'Tipo', 'Fecha_mod', 'Fecha_registro', 'DatosOCS.TIPO'  
      ]"
      :loading="loadingEquipos"
      scrollable
      responsiveLayout="scroll"
      scrollDirection="both"
      scrollHeight="550px"
      showGridlines
      :rowHover="true"
      class="p-datatable-gridlines"
      :resizableColumns="true"
      :frozenWidth="200"
      columnResizeMode="fit">

      <template #header>
        <div class="table-header">
          <h5>Equipos</h5>
          <span>
            Número de equipos
            {{ lstEquipos ? lstEquipos.length : 0 }}
          </span>
          <span class="p-input-icon-left">
            <i class="pi pi-search" />
            <InputText v-model="filtersSegmentados['global'].value" placeholder="Buscar..."/>
          </span>
        </div>
      </template>

      <template #empty> No se encontraron registros. </template>
      <template #loadingEquipos>Cargando datos. Espere por favor.</template>

      <Column field="Botones" header="Botones" :frozen="true" :sortable="false" style="width: 100px; position: sticky; left: 0; z-index: 2">
        <template #body="slotProps">
          <div class="botones-container">
            <Button
              v-show="slotProps.data.Id_equipo_computo !== 0 && shouldShowButton(slotProps.data)"
              icon="pi pi-times"
              class="p-button-rounded p-button-danger"
              @click="borrarEquipo(slotProps.data)"
              style="width: 30px; height: 30px"
            />
            <Button
              id="id-cancelar-cambios"
              icon="pi pi-undo"
              class="p-button-rounded p-button-primary"
              @click="cancelarCambiosFila(slotProps.data)"
              style="width: 30px; height: 30px; margin-left: 5px;"
              v-show="slotProps.data.mostrarCancelar"
            />
          </div>
        </template>
      </Column>

      <Column field="IP" header="IP" :showFilterMenu="false" sortable :frozen="true" style="min-width: 120px; position: sticky; left: 100px; z-index: 2"/>

      <Column field="Tipo" header="TIPO" sortable :editable="true">
        <template #body="{ data, field }">
          <template v-if="lstEquipos.indexOf(data) >= 10 && lstEquipos.indexOf(data) < lstEquipos.length - 15">
            <Dropdown
              :id="'campoTipo_' + lstEquipos.indexOf(data)"
              v-model="data[field]"
              :options="lstTipos"
              optionLabel="Tipo"
              optionValue="Tipo"
              class="p-column-filter"
              style="width: 100%"
              @click="guardarValorOriginal(data, field)"
              @change="(e) => EditarEquipo({
                data: data,
                field: field,
                value: data._valorOriginal || data[field],
                newValue: e.value
              })"
            />
          </template>
          <template v-else>
            <span>{{ data[field] }}</span>
          </template>
        </template>
      </Column>
      
      <Column field="Marca" header="MARCA" sortable :editable="true">
        <template #body="{ data, field }">
          <template v-if="lstEquipos.indexOf(data) >= 10 && lstEquipos.indexOf(data) < lstEquipos.length - 15">
            <InputText
              :id="'campoMarca_' + lstEquipos.indexOf(data)"
              :value="data[field]"
              :class="{ resaltar: data[field] === 'algún valor específico' }"
              @input="(e) => {
                data[field] = e.target.value;
                quitarClaseResaltar(e.target); 
              }"
              @click="guardarValorOriginal(data, field)"
              @blur="(e) => EditarEquipo({
                data: data,
                field: field,
                value: data._valorOriginal || data[field],
                newValue: e.target.value
              })"
            />
          </template>
          <template v-else>
            <span>{{ data[field] }}</span>
          </template>
        </template>
      </Column>

      <Column field="Modelo" header="MODELO" sortable :editable="true">
        <template #body="{ data, field }">
          <template v-if="lstEquipos.indexOf(data) >= 10 && lstEquipos.indexOf(data) < lstEquipos.length - 15">
            <InputText
              :id="'campoModelo_' + lstEquipos.indexOf(data)"
              :value="data[field]"
              :class="{ resaltar: data[field] === 'algún valor específico' }"
              @input="(e) => {
                data[field] = e.target.value;
                quitarClaseResaltar(e.target);
              }"
              @click="guardarValorOriginal(data, field)"
              @blur="(e) => EditarEquipo({
                data: data,
                field: field,
                value: data._valorOriginal || data[field],
                newValue: e.target.value
              })"
            />
          </template>
          <template v-else>
            <span>{{ data[field] }}</span>
          </template>
        </template>
      </Column>
      
      <Column field="Serie" header="SERIE" sortable :editable="true">
        <template #body="{ data, field }">
          <template v-if="lstEquipos.indexOf(data) >= 10 && lstEquipos.indexOf(data) < lstEquipos.length - 15">
            <InputText 
              :id="'campoSerie_' + lstEquipos.indexOf(data)"
              :value="data[field]"
              @input="(e) => data[field] = e.target.value"
              @click="guardarValorOriginal(data, field)"
              @blur="(e) => EditarEquipo({
                data: data,
                field: field,
                value: data._valorOriginal || data[field],
                newValue: e.target.value
              })"
            />
          </template>
          <template v-else>
            <span>{{ data[field] }}</span>
          </template>
        </template>
      </Column>
      
      <Column field="Usuario" header="USUARIO" sortable :editable="true">
        <template #body="{ data, field }">
          <template v-if="lstEquipos.indexOf(data) >= 10 && lstEquipos.indexOf(data) < lstEquipos.length - 15">
            <InputText 
              :id="'campoUsuario_' + lstEquipos.indexOf(data)"
              :value="data[field]"
              @input="(e) => data[field] = e.target.value"
              @click="guardarValorOriginal(data, field)"
              @blur="(e) => EditarEquipo({
                data: data,
                field: field,
                value: data._valorOriginal || data[field],
                newValue: e.target.value
              })"
            />
          </template>
          <template v-else>
            <span>{{ data[field] }}</span>
          </template>
        </template>
      </Column>

      <Column field="Nombre_equipo" header="NOMBRE DEL EQUIPO" sortable :editable="true">
        <template #body="{ data, field }">
          <template v-if="lstEquipos.indexOf(data) >= 10 && lstEquipos.indexOf(data) < lstEquipos.length - 15">
            <InputText 
              :id="'campoNombre_equipo_' + lstEquipos.indexOf(data)"
              :value="data[field]"
              @input="(e) => data[field] = e.target.value"
              @click="guardarValorOriginal(data, field)"
              @blur="(e) => EditarEquipo({
                data: data,
                field: field,
                value: data._valorOriginal || data[field],
                newValue: e.target.value
              })"
            />
          </template>
          <template v-else>
            <span>{{ data[field] }}</span>
          </template>
        </template>
      </Column>

      <Column field="MAC" header="MAC" sortable :editable="true">
        <template #body="{ data, field }">
          <template v-if="lstEquipos.indexOf(data) >= 10 && lstEquipos.indexOf(data) < lstEquipos.length - 15">
            <InputText 
              :value="data[field]"
              @input="(e) => data[field] = e.target.value"
              @click="guardarValorOriginal(data, field)"
              @blur="(e) => EditarEquipo({
                data: data,
                field: field,
                value: data._valorOriginal || data[field],
                newValue: e.target.value
              })"
            />
          </template>
          <template v-else>
            <span>{{ data[field] }}</span>
          </template>
        </template>
      </Column>

      <Column field="SO" header="SISTEMA OPERATIVO" sortable :editable="true">
        <template #body="{ data, field }">
          <template v-if="lstEquipos.indexOf(data) >= 10 && lstEquipos.indexOf(data) < lstEquipos.length - 15">
            <InputText 
              :value="data[field]"
              @input="(e) => data[field] = e.target.value"
              @click="guardarValorOriginal(data, field)"
              @blur="(e) => EditarEquipo({
                data: data,
                field: field,
                value: data._valorOriginal || data[field],
                newValue: e.target.value
              })"
            />
          </template>
          <template v-else>
            <span>{{ data[field] }}</span>
          </template>
        </template>
      </Column>
      
      <Column field="Descripcion" header="DESCRIPCION" sortable :editable="true">
        <template #body="{ data, field }">
          <template v-if="lstEquipos.indexOf(data) >= 10 && lstEquipos.indexOf(data) < lstEquipos.length - 15">
            <InputText 
              :value="data[field]"
              @input="(e) => data[field] = e.target.value"
              @click="guardarValorOriginal(data, field)"
              @blur="(e) => EditarEquipo({
                data: data,
                field: field,
                value: data._valorOriginal || data[field],
                newValue: e.target.value
              })"
            />
          </template>
          <template v-else>
            <span>{{ data[field] }}</span>
          </template>
        </template>
      </Column>
      
      <Column field="Ubicacion" header="UBICACIÓN" sortable :editable="true">
        <template #body="{ data, field }">
          <template v-if="lstEquipos.indexOf(data) >= 10 && lstEquipos.indexOf(data) < lstEquipos.length - 15">
            <InputText 
              :value="data[field]"
              @input="(e) => data[field] = e.target.value"
              @click="guardarValorOriginal(data, field)"
              @blur="(e) => EditarEquipo({
                data: data,
                field: field,
                value: data._valorOriginal || data[field],
                newValue: e.target.value
              })"
            />
          </template>
          <template v-else>
            <span>{{ data[field] }}</span>
          </template>
        </template>
      </Column>
      
      <Column field="Area" header="ÁREA" sortable :editable="true">
        <template #body="{ data, field }">
          <template v-if="lstEquipos.indexOf(data) >= 10 && lstEquipos.indexOf(data) < lstEquipos.length - 15">
            <InputText 
              :value="data[field]"
              @input="(e) => data[field] = e.target.value"
              @click="guardarValorOriginal(data, field)"
              @blur="(e) => EditarEquipo({
                data: data,
                field: field,
                value: data._valorOriginal || data[field],
                newValue: e.target.value
              })"
            />
          </template>
          <template v-else>
            <span>{{ data[field] }}</span>
          </template>
        </template>
      </Column>
      
      <Column field="NNI" header="NNI" sortable :editable="true">
        <template #body="{ data, field }">
          <template v-if="lstEquipos.indexOf(data) >= 10 && lstEquipos.indexOf(data) < lstEquipos.length - 15">
            <InputText 
              :value="data[field]"
              @input="(e) => data[field] = e.target.value"
              @click="guardarValorOriginal(data, field)"
              @blur="(e) => EditarEquipo({
                data: data,
                field: field,
                value: data._valorOriginal || data[field],
                newValue: e.target.value
              })"
            />
          </template>
          <template v-else>
            <span>{{ data[field] }}</span>
          </template>
        </template>
      </Column>
      
      <Column field="Fecha_registro" header="FECHA REGISTRO" sortable>
        <template #body="slotProps">
          {{ getFechaWCF(slotProps.data.Fecha_registro, true) }}
        </template>
      </Column>
      
      <Column field="Fecha_mod" header="FECHA MODIFICACIÓN" sortable>
        <template #body="slotProps">
          {{ getFechaWCF(slotProps.data.Fecha_mod, true) }}
        </template>
      </Column>
      
      <Column field="Observaciones" header="OBSERVACIONES" sortable :editable="true">
        <template #body="{ data, field }">
          <template v-if="lstEquipos.indexOf(data) >= 10 && lstEquipos.indexOf(data) < lstEquipos.length - 15">
            <template v-if="data.DatosOCS && data.DatosInventario && equiposOCS(data)">
              {{ data.DatosInventario.Observacion }}
            </template>
            <InputText 
              v-else
              :value="data[field]"
              @input="(e) => data[field] = e.target.value"
              @click="guardarValorOriginal(data, field)"
              @blur="(e) => EditarEquipo({
                data: data,
                field: field,
                value: data._valorOriginal || data[field],
                newValue: e.target.value
              })"
            />
          </template>
          <template v-else>
            <span>{{ data[field] }}</span>
          </template>
        </template>
      </Column>
      <template #footer>
        Registros en total {{ lstEquipos ? lstEquipos.length : 0 }}
      </template>
    </DataTable>
    <ConfirmDialog></ConfirmDialog>
  </div>
</template>

<script>
import Srvr from "../service/Inventario";
import SrvrEquipos from "../service/EquiposComputo";
import { FilterMatchMode } from "primevue/api";
import Utilerias from "../utilidades/Utilerias";
import { mapGetters } from "vuex";
import { ConfirmDialog } from 'primevue/confirmdialog';

export default {
  components: {
    ConfirmDialog
  },
  data() {
    return {
      lstUnidades: [],
      selectedUnidadFiltro: null,
      lstEquipos: null,
      lstEquiposOriginales: null,
      imageUrl: null,
      fileName: "",
      lstTipos: [
        {
          Tipo: "COMPUTADORA",
        },
        {
          Tipo: "LAPTOP",
        },
        {
          Tipo: "MULTIFUNCIONAL",
        },
        {
          Tipo: "SERVIDOR",
        },
        {
          Tipo: "PROVEEDOR",
        },
        {
          Tipo: "IMPRESORA",
        },
        {
          Tipo: "PANTALLA",
        },
        {
          Tipo: "LECTOR DE BARRAS",
        },
        {
          Tipo: "SCANNER",
        },
        {
          Tipo: "DIADEMA",
        },
        {
          Tipo: "CAMARA WEB",
        },
        {
          Tipo: "UPS",
        },
      ],
      filtersSegmentados: {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
      loading: true,
      loadingEquipos: false,
      submitted: false,
      showAgregar: false,
      dialogVisible: false,
      dialogEvidenciasVisible: false,
      showNuevaVerificacion: false,
      equipoEdited: null,
      modoEdicion: "",
      expandedRows: [],
      expandedRowsSegmentados: [],
      DatosOCS: [],
      equipo: {},
      activeTabIndex: 0,
      evidencia: {
        IP_equipo: "",
        Matricula_realizo: "",
        Nombres: '',
        URL_imagen: "",
        Observaciones: "",
        Fecha: '',
        Referencia_red: "",  
        Area: "",            
        Usuario: "",
        Unidad: '',  
        Id_lista_verificacion: null,    
      },
      showDialog: false,
      showGallery: false,
      selectedEquipo: null,
      modifiedIPs: new Map(),
      originalIPs: new Map(),
      lstEquiposAnteriores: [],
      FilasEditadas: [],
    };
  },
  created() {
  },
  mounted() {
    this.loadUserData();
    var t = this;
    t.cargaInicial();
  },
  methods: {
    rowClass(data) {
      const index = this.lstEquipos.indexOf(data);
      const lastIndex = this.lstEquipos.length - 1;
      const filasSatelites = 126;
      const ultimasFilasSatelites = 119;
      const filasTotales = 254;
      const ultimasFilasTotales = 14;
      const primerasFilasApartadas = 10;

      if (index < primerasFilasApartadas) {
        return "filas-reservadas";
      }
      if (
        this.lstEquipos.length == filasSatelites &&
        index >= ultimasFilasSatelites &&
        index <= filasSatelites
      ) {
        return "filas-reservadas";
      }
      if (
        this.lstEquipos.length == filasTotales &&
        index >= lastIndex - ultimasFilasTotales
      ) {
        return "filas-reservadas";
      }
      return "";
    },
    shouldShowButton(data, rowIndex) {
      const totalRows = this.lstEquipos.length;
      const isReservedRow = rowIndex < 10 || rowIndex >= totalRows - 14;
      return !isReservedRow && (!data.DatosOCS || (data.DatosOCS && !this.equiposOCS(data)));
    },
    equiposOCS(data) {
      return [
        "BIOMETRICO",
        "BIOMÉTRICO",
        "PROVEEDOR",
        "SERVIDOR",
        "CÁMARA",
        "CÁMARAS",
        "CONMUTADOR",
        "TELÉFONO IP",
        "DVR",
        "INALÁMBRICO",
        "INALAMBRICO",
        "ROUTER",
        "SWITCH",
      ].includes(data.DatosOCS.TIPO);
    },
    getFechaWCF(fecha) {
      var utils = new Utilerias();
      return utils.getFechaWCF(fecha);
    },
    cargaInicial() {
      var t = this;
      var ctlSvr = new Srvr();
      ctlSvr.getUnidades(t).then((res) => {
        t.lstUnidades = res;
      });
    },
    cargaEquiposPorUnidad() {
      var t = this;
      var ctlSvr = new SrvrEquipos();
      const checklist = document.getElementById('id_datos_OCS');
      const conDatosOCS = checklist.checked;
    
      t.loadingEquipos = true;
      t.loadingTab2 = true;
      this.expandedRowsSegmentados = null;
      
      ctlSvr.getEquiposComputo(t, t.selectedUnidadFiltro.SUBRED, conDatosOCS)
        .then((res) => {
          // Mapear los equipos con las propiedades básicas necesarias
          t.lstEquipos = res.map(equipo => ({
            ...equipo,
            mostrarCancelar: false
          }));
    
          // Mantener una copia original para comparaciones
          t.lstEquiposOriginales = res.map(equipo => ({
            ...equipo,
            mostrarCancelar: false
          }));
    
          t.loadingEquipos = false;
          t.loadingTab2 = false;
        })
        .catch(error => {
          console.error('Error loading data:', error);
          t.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Error al cargar los equipos',
            life: 3000
          });
          t.loadingEquipos = false;
          t.loadingTab2 = false;
        });

    },
    borrarEquipo(obj) {
      const t = this;
      const id_usuario = t.getUsuarioLogueado.Usuario.Id_usuario;
      const val = obj.Id_equipo_computo;

      t.$confirm.require({
        message: '¿Quiere eliminar este equipo? No podrá recuperar los cambios.',
        header: 'Confirmación',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Sí, eliminar',
        rejectLabel: 'Cancelar',
        acceptClass: 'p-button-danger',
        accept: () => {
          const ctlSvr = new SrvrEquipos();
          ctlSvr.deleteEquipoComputo(t, val, id_usuario).then(() => {
            // Índices en arrays
            const indexEquipos = t.lstEquipos.findIndex(e => e.Id_equipo_computo === val);
            const indexOriginales = t.lstEquiposOriginales.findIndex(e => e.Id_equipo_computo === val);

            // Objeto vacío
            const equipoVacio = {
              Id_equipo_computo: 0,
              Tipo: '',
              Marca: '',
              Modelo: '',
              SO: '',
              Serie: '',
              Usuario: '',
              Nombre_equipo: '',
              Descripcion: '',
              Ubicacion: '',
              Area: '',
              MAC: '',
              NNI: '',
              Observaciones: ''
            };

            // Actualizar arrays
            if (indexEquipos !== -1) {
              t.lstEquipos[indexEquipos] = {
                ...t.lstEquipos[indexEquipos],
                ...equipoVacio
              };
            }

            if (indexOriginales !== -1) {
              t.lstEquiposOriginales[indexOriginales] = {
                ...t.lstEquiposOriginales[indexOriginales],
                ...equipoVacio
              };
            }

            // Notificación
            t.$toast.add({
              severity: 'success',
              summary: 'AVISO',
              detail: 'Equipo eliminado correctamente',
              life: 3000
            });
          });
        },
        reject: () => {
          // Usuario canceló
        }
      });
    },
    loadUserData() {
        const userString = localStorage.getItem('user');
        if (userString) {
          const user = JSON.parse(userString);
          const matricula = user.Usuario.Matricula;
          this.user = user;
          this.evidencia.Matricula_realizo = matricula;
          this.consultarEmpleado();
          } else {
          console.log('No se encontró el valor en localStorage.');
        }
    },
    consultarEmpleado(){
      const matricula = this.evidencia.Matricula_realizo;
      if (matricula) {
        this.matriculaEmpleado(matricula);
      }else {
        this.evidencia.Nombres = '';
      }
    },
    matriculaEmpleado(matricula) {
      var t = this;
      const srvrEquipos = new SrvrEquipos();
      t.loading = true;
      srvrEquipos.getEmpleado(t, matricula)
        .then((res) => {
          if (res) {
            t.evidencia.Nombres = `${res.Nombres || ''} ${res.Ap_pat || ''} ${res.Ap_mat || ''}`.trim();
          } else {
            t.evidencia.Nombres = '';
            t.evidencia.Apellidos = '';
            t.$toast.add({ severity: 'warn', summary: 'Advertencia', detail: 'Empleado no encontrado', life: 3000 });
          }
          t.loading = false;
        })
        .catch(function (error) {
          console.error("Error:", error);
          t.loading = false;
          t.$toast.add({ severity: 'error', summary: 'Error', detail: 'Error consultando el empleado', life: 3000 });
        });
    },
    descartarCambios() {
      if (!this.hasChanges) return;

      if (confirm('¿Desea descartar todos los cambios realizados?')) {
        this.lstEquipos = this.lstEquipos.map(equipo => ({
          ...equipo,
          tempIP: this.originalIPs.get(equipo.Id_equipo_computo) || equipo.IP
        }));

        this.modifiedIPs.clear();
        this.hasChanges = false;

        this.$toast.add({
          severity: 'info',
          summary: 'Cambios Descartados',
          detail: 'Se han restaurado los valores originales',
          life: 3000
        });
      }
    },
    guardarCambios() {
      var t = this;
      t.submitted = true;
      t.loading = true;
      let hayErrores = false;
    
      // Definir campos requeridos
      const camposRequeridos = ['Tipo', 'Marca', 'Modelo', 'Serie', 'Usuario', 'Nombre_equipo'];
    
      // Primera fase: Validación
      const cambiosProcesados = t.lstEquipos.reduce((cambios, equipoActual, index) => {
        const equipoOriginal = t.lstEquiposOriginales.find(eq => eq.IP === equipoActual.IP);
        
        if (!equipoOriginal) return cambios;
    
        const camposModificados = [
          'Marca', 'Tipo', 'Modelo', 'SO', 'Serie', 'Usuario', 
          'Nombre_equipo', 'Descripcion', 'Ubicacion', 'Area',
          'MAC', 'NNI', 'Observaciones'
        ];
    
        // Verificar si al menos uno de los campos principales tiene contenido
        const tieneDatosRelevantes = camposRequeridos.some(
          campo => equipoActual[campo] && equipoActual[campo].trim() !== ""
        );
    
        // Solo validar si tiene al menos un campo con datos
        if (tieneDatosRelevantes) {
          camposRequeridos.forEach(campo => {
            const elemento = document.getElementById(`campo${campo}_${index}`);
            if (elemento) {
              if (!equipoActual[campo] || equipoActual[campo].trim() === "") {
                elemento.classList.add("resaltar");
                elemento.setAttribute("aria-invalid", "true");
                hayErrores = true;
              } else {
                elemento.classList.remove("resaltar");
                elemento.removeAttribute("aria-invalid");
              }
            }
          });
        }
    
        const changes = {};
        let hayCambios = false;
    
        camposModificados.forEach(campo => {
          if (equipoActual[campo] !== equipoOriginal[campo]) {
            changes[campo] = equipoActual[campo];
            hayCambios = true;
          }
        });
    
        // Solo incluir en cambios si todos los campos requeridos están completos
        if (hayCambios) {
          const todosLosCamposRequeridosCompletos = !tieneDatosRelevantes || 
            (tieneDatosRelevantes && camposRequeridos.every(campo => 
              equipoActual[campo] && equipoActual[campo].trim() !== ""
            ));

          if (todosLosCamposRequeridosCompletos) {
            cambios.push({
              IP: equipoActual.IP,
              datosOriginales: equipoOriginal,
              datosActualizados: {
                ...equipoOriginal,
                ...changes,
                Id_usuario_registro: t.getUsuarioLogueado.Usuario.Id_usuario
              },
              camposModificados: Object.keys(changes)
            });
          }
        }
    
        return cambios;
      }, []);
    
      // Si hay errores de validación, mostrar mensaje y detener el proceso
      if (hayErrores) {
        t.$toast.add({
          severity: 'warn',
          summary: 'Error de validación',
          detail: 'Todos los campos (Tipo, Marca, Modelo, Serie, Usuario y Nombre equipo) son obligatorios cuando se ingresa información en cualquiera de ellos',
          life: 3000
        });
        t.loading = false;
        return;
      }
    
      // Si no hay cambios para guardar
      if (cambiosProcesados.length === 0) {
        t.$toast.add({
          severity: 'warn',
          summary: 'Sin cambios',
          detail: 'No hay cambios pendientes para guardar',
          life: 3000
        });
        t.loading = false;
        return;
      }
    
      // Segunda fase: Guardar cambios
      var ctlSvr = new SrvrEquipos();
    
      const guardarCambio = (cambio) => {
        const equipoData = {
          ...cambio.datosActualizados,
          Unidad: t.selectedUnidadFiltro?.UNIDAD || '',
          Subred: t.selectedUnidadFiltro?.SUBRED || '',
          Id_usuario_registro: t.getUsuarioLogueado.Usuario.Id_usuario
        };
    
        if (equipoData.IP && !t.validarEstructuraIP(equipoData.IP)) {
          return Promise.reject(new Error(`IP inválida: ${equipoData.IP}`));
        }
    
        // Asignar valores por defecto para campos vacíos
        ['NNI', 'MAC', 'Ubicacion', 
         'Area', 'SO', 'Descripcion', 'Observaciones'].forEach(campo => {
          if (!equipoData[campo]) equipoData[campo] = "";
        });
    
        return equipoData.Id_equipo_computo ? 
          ctlSvr.updateEquipoComputo(t, equipoData) : 
          ctlSvr.addEquipoComputo(t, equipoData);
      };
    
      // Deshabilitar el botón de guardar
      const btnGuardar = document.getElementById('btn-guardar');
      if (btnGuardar) {
        btnGuardar.disabled = true;
      }
    
      const promesas = cambiosProcesados.map(guardarCambio);
    
      Promise.all(promesas)
        .then(() => {
          t.$toast.add({
            severity: 'success',
            summary: 'Éxito',
            detail: 'Cambios guardados correctamente',
            life: 3000
          });
          t.FilasEditadas = [];
          return t.cargaEquiposPorUnidad();
        })
        .catch(error => {
          t.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: error.message || 'Error al guardar los cambios',
            life: 3000
          });
        })
        .finally(() => {
          t.loading = false;
          if (btnGuardar) {
            btnGuardar.disabled = false;
          }
        });
    },
    validarEstructuraIP(ip) {
      const ipRegex = /^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/;
      return ipRegex.test(ip);
    },
    cancelarTodo(){
      this.FilasEditadas = [];
      this.cargaEquiposPorUnidad();
    },
    EditarEquipo(event) {
      const { data, field } = event;
      const equipoOriginal = this.lstEquiposOriginales.find(eq => eq.IP === data.IP);

      if(equipoOriginal[field] !== data[field]) {

        if (!equipoOriginal) return;
        const hayCambios = Object.keys(equipoOriginal).some(key => data[key] !== equipoOriginal[key]);
        data.mostrarCancelar = hayCambios;
      }else{
        data.mostrarCancelar = false;
      }

    },
    guardarValorOriginal(data, field) {
      if (!data._valoresOriginales) {
        data._valoresOriginales = {};
      }
      if (!data._valoresOriginales[field]) {
        data._valoresOriginales[field] = data[field];
      }
    },
    cancelarCambiosFila(equipo) {      
      const filaEditada = this.FilasEditadas.find(fila => fila.IP === equipo.IP);
      let cambiosEncontrados = false;

      const equipoOriginal = this.lstEquiposOriginales.find(eq => eq.IP === equipo.IP);
      const index = this.lstEquiposOriginales.findIndex(eq => eq.IP === equipo.IP);
      
      if (equipoOriginal) {
        const camposEditables = [
          'Marca', 'Tipo', 'Modelo', 'SO', 'Serie', 'Usuario', 
          'Nombre_equipo', 'Descripcion', 'Ubicacion', 'Area',
          'MAC', 'NNI', 'Observaciones'
        ];

        camposEditables.forEach(campo => {
          if (equipo[campo] !== equipoOriginal[campo]) {
            equipo[campo] = equipoOriginal[campo];
            cambiosEncontrados = true;
          }
        });

        if (equipo._valoresOriginales) {
          delete equipo._valoresOriginales;

          const campoTipo = document.getElementById("campoTipo_" + index);
          const campoMarca = document.getElementById("campoMarca_" + index);
          const campoModelo = document.getElementById("campoModelo_" + index);

          if (campoTipo && campoTipo.classList.contains("resaltar")) {
              campoTipo.classList.remove("resaltar");
          }

          if (campoMarca && campoMarca.classList.contains("resaltar")) {
              campoMarca.classList.remove("resaltar");
          }

          if (campoModelo && campoModelo.classList.contains("resaltar")) {
              campoModelo.classList.remove("resaltar");
          }
        }
        
        equipo.mostrarCancelar = false;
      }

      if (filaEditada) {
        this.FilasEditadas = this.FilasEditadas.filter(fila => fila.IP !== equipo.IP);
        cambiosEncontrados = true;
      }

      if (cambiosEncontrados) {
        this.$toast.add({
          severity: 'success',
          summary: 'Cambios cancelados',
          detail: 'Se han restaurado los valores originales',
          life: 3000
        });
      } else {
        this.$toast.add({
          severity: 'info',
          summary: 'Sin cambios',
          detail: `No se encontraron cambios para cancelar en el equipo con IP ${equipo.IP}`,
          life: 3000
        });
      }
    },
    quitarClaseResaltar(elemento) {
      if (elemento.classList.contains('resaltar')) {
        elemento.classList.remove('resaltar');
      }
    }
  },
  computed: {
    ...mapGetters(["getUrlServicios", "getUsuarioLogueado"]),
  },
};
</script>

<style scoped>
    /* .loading-overlay {
    position: relative;
  }
  
  .loading-overlay::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.7);
    z-index: 4;
    pointer-events: none;
  }
  
  :deep(.loading-column) {
    position: relative;
  }
  
  :deep(.loading-column::before) {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.7);
    z-index: 4;
    pointer-events: none;
  } */

  .resaltar {
    border: 2px solid red !important;
    background-color: rgba(255, 0, 0, 0.1);
  }

  .table-header {
    display: flex;
    justify-content: space-between;
    -webkit-box-pack: justify;
  }

  .botones-container {
    display: flex;
    justify-content: left;
    align-items: left;
  }

  .close-button {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 1000;
    background: transparent;
    background: transparent;
    border: none;
    border: none;
    margin: 3px; /* Sin margen extra */
    padding: 0;
    opacity: 0;
    cursor: pointer; /* Indicar que es clicable */
    transition: opacity 0.2s, transform 0.2s;
    width: 40px; /* Ancho más grande */
    width: 50px;  /* Adjust the size as needed */
    height: 40px; /* Altura más pequeña para hacerlo cuadrado */
    height: 50px;
    border-radius: 4px; /* Bordes ligeramente redondeados */
    margin: 0.5rem;
    border-radius: 50%;
  }

  .close-button:hover {
    opacity: 1; /* Efecto hover para mayor visibilidad */
    transform: scale(1.1); /* Efecto de zoom */
  }
  .image-preview-container {
    display: flex;
    align-items: center;
    border: 2px solid #ccc;
    border-radius: 4px;
    padding: 10px;
    margin-top: 10px;
  }
  .image-preview {
    margin-right: 10px;
  }
  .image-preview img {
    max-width: 155px;
    height: auto;
    display: block;
  }

  .image-info {
    position: relative;
    flex: 1;
  }
  .image-info label {
    display: block;
    margin-bottom: 5px;
  }
  textarea {
    width: 35%;
    resize: none;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 8px;
    box-sizing: border-box;
  }

  .p-field {
    display: flex;
    justify-content: space-between; /* Espacio uniforme entre elementos */
    align-items: center;
    flex-wrap: wrap; /* Permitir ajuste si el espacio es insuficiente */
  }

  .field-item {
    flex: 0 0 auto; /* Evita que los elementos se expandan para ocupar todo el espacio disponible */
    text-align: left;
    margin-right: 0; /* Ajusta el espacio entre los elementos */
    font-size: 1.3rem; /* Reduce ligeramente el tamaño de fuente */
    line-height: 1; /* Reduce el espaciado vertical de cada línea */
    margin: 0; /* Elimina márgenes */
      padding: 0.2rem 0.5rem; /* Ajusta el padding para que sea más compacto */
      font-weight: normal; /* Cambia el peso de la fuente si es necesario */
  }

  h5 {
    margin: 0; /* Sin margen adicional */
  }

  .opacity-box {
      background-color: rgba(255, 255, 255, 0.5); /* Fondo blanco con 50% de opacidad */
      padding: 0.5rem 1rem; /* Espaciado interno */
      border-radius: 10px; /* Bordes redondeados */
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2); /* Sombra para un efecto de elevación */
  }
  .p-field.p-flex {
    display: flex;
    flex-wrap: wrap; /* Permite que los elementos se ajusten en varias líneas si es necesario */
    gap: 1rem; /* Espacio entre cada elemento, ajusta según tus necesidades */
    align-items: center; /* Alinea verticalmente los elementos en el centro */
  }
 
  .wrapper-list {
    flex: 1 1 auto;
  
    overflow-y: auto; /* Permite el scroll vertical aquí */
  }

  .DataTable .p-datatable-tbody > tr {
      height: auto;
      padding: 0.5rem;
  }
 
  .observaciones-box {
      max-height: 60px; /* Limitar la altura para observaciones largas */
      overflow-y: auto; /* Habilitar scroll si el texto es muy largo */
      padding: 0.5rem;
      background-color: #f9f9f9;
      border: 1px solid #ddd;
      border-radius: 4px;
  }
 
  .observacion-text {
      font-size: 0.9rem;
      line-height: 1.4;
      white-space: pre-line; /* Mantener los saltos de línea */
  }
 
  .preview-image {
      cursor: pointer;
      border-radius: 4px;
      transition: transform 0.2s;
  }
 
  .preview-image:hover {
      transform: scale(1.1); /* Efecto de zoom */
  }
  .opacity-box {
    padding-bottom: 0;
    background-color: transparent; /* Elimina el color de fondo */
    box-shadow: none; /* Quita cualquier sombra */
    border: none; /* Quita el borde */
    padding: 0; /* Ajusta el padding */
    margin: 0; /* Ajusta el margen */
  }
  .opacity-box,
    .root {
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: hidden; /* Evita que el scroll esté en el contenedor, lo mantenemos solo en .wrapper-list */
  }

  .DataTable {

      width: 100%;  
  }
  .p-datatable-wrapper {
    flex: 1;
      display: flex;
      flex-direction: column;
      overflow-y: auto;
  }
  .header-section { /* Nombre de la clase para la sección de información */
    flex: 0 0 auto;
    padding: 0.5rem 1rem; /* Ajusta el padding si es necesario */
  }
  .highlight-title {
    background-color: #f0f8ff; /* Fondo azul claro */
    padding: 10px;
    border-bottom: 4px solid #007acc; /* Borde azul */
    color: #003366; /* Texto en color azul oscuro */
    font-weight: bold;
    text-transform: uppercase;
  }
  .highlight-title1 {
      background-color: #f0f8ff; /* Fondo azul claro */
      padding: 10px;
      border-bottom: 4px solid #41f044; /* Borde azul */
      color: #0f833f; /* Texto en color azul oscuro */
      font-weight: bold;
      text-transform: uppercase;
  }
  .highlight-title2 {
      background-color: #f0f8ff; /* Fondo azul claro */
      padding: 10px;
      border-bottom: 4px solid rgb(235, 156, 80); /* Borde azul */
      color: #c4882e; /* Texto en color azul oscuro */
      font-weight: bold;
      text-transform: uppercase;
  }
  .highlight-title3 {
      background-color: #f0f8ff; /* Fondo azul claro */
      padding: 10px;
      border-bottom: 4px solid #4f5da6; /* Borde azul */
      color: #2d3f99; /* Texto en color azul oscuro */
      font-weight: bold;
      text-transform: uppercase;
  }
  .highlight-title4 {
      background-color: #f0f8ff; /* Fondo azul claro */
      padding: 10px;
      border-bottom: 4px solid rgb(203, 106, 162); /* Borde azul */
      color:rgb(203, 106, 162); /* Texto en color azul oscuro */
      font-weight: bold;
      text-transform: uppercase;
  }
  :deep(.p-datatable-wrapper) {
    position: relative;
  }

  :deep(.p-datatable-thead) {
    position: sticky;
    top: 0;
    z-index: 3;
    background-color: white;
  }

  :deep(.p-datatable-thead th) {
    position: sticky;
    top: 0;
    z-index: 3;
    background-color: white;
  }

  :deep(.p-datatable-frozen-column) {
    position: sticky;
    background-color: white;
  }

  :deep(.p-datatable-scrollable-header) {
    overflow: visible !important;
  }

  :deep(.p-datatable-scrollable-body) {
    overflow: auto;
  }

  :deep(.p-datatable-frozen-column)::after {
    content: '';
    position: absolute;
    top: 0;
    right: -8px;
    height: 100%;
    width: 8px;
    background: linear-gradient(to right, rgba(0,0,0,0.1), transparent);
  }
</style>